/**
 * Cookie com o idioma que a pessoa escolheu. Sem ele vale o idioma do
 * navegador (`Accept-Language` no servidor, `navigator.languages` no cliente).
 * Só a escolha explícita grava o cookie: a detecção não, para que trocar o
 * idioma do navegador continue valendo para quem nunca escolheu.
 */
export const LOCALE_COOKIE = "tami-locale";

/** Um ano: a escolha de idioma não expira com a sessão. */
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;
